// @ts-nocheck

export type TicketListWithProperty = typeof TicketListWithProperty[keyof typeof TicketListWithProperty];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TicketListWithProperty = {
  true: 'true',
  false: 'false',
} as const;
